import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Router } from './UI/router';
import { ToastContainer } from 'react-toastify';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router />
    <ToastContainer/>
  </React.StrictMode>
);

